import i18next from "i18next";
import languageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import enGB from "./en-GB.json";
import de from "./de-DE.json";
import ja from "./ja-JP.json";
import ko from "./ko-KR.json";
import vi from "./vi-VN.json";
import zh from "./zh-TW.json";
import fr from "./fr-FR.json";
import frCA from "./fr-CA.json";
import es from "./es-MX.json";
import cn from "./zh-CN.json";
import ph from "./ph-PH.json";

i18next
  .use(languageDetector)
  .use(initReactI18next)
  .init({
    defaultNS: "translation",
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"], // where to persist
    },
  });

i18next.addResourceBundle("en", "translation", en);
i18next.addResourceBundle("en-GB", "translation", enGB);
i18next.addResourceBundle("es-MX", "translation", es);
i18next.addResourceBundle("fr-CA", "translation", frCA);
i18next.addResourceBundle("fr-FR", "translation", fr);
i18next.addResourceBundle("de-DE", "translation", de);
i18next.addResourceBundle("ja-JP", "translation", ja);
i18next.addResourceBundle("ko-KR", "translation", ko);
i18next.addResourceBundle("vi-VN", "translation", vi);
i18next.addResourceBundle("zh-CN", "translation", cn);
i18next.addResourceBundle("zh-TW", "translation", zh);
i18next.addResourceBundle("ph-PH", "translation", ph);

export default i18next;

export const t = (...args) => i18next.t(...args);
